import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { distinctUntilChanged } from 'rxjs/operators';
// ngrx/store
import { Store } from '@ngrx/store';
import * as fromRoot from '../../reducers'
import * as users from '../../actions/user.actions';

@Component({
  selector: 'sidebar-screens',
  templateUrl: 'sidebar-screens.html'
})
export class SidebarScreensComponent {
  @Input() sectors: any = [];
  @Input() regions: any = [];
  @Input() syntheticRegions: any = [];
  @Input() filterName: any;
  @Input() sidebar: string;
  @Input() dataRanges: any;
  foods: any[];
  selectedValue: string;
  filter: any;

  constructor(
    public store: Store<fromRoot.State>,
  ) {
    this.filter = this.store.select(fromRoot.getScreensFilter).pipe(distinctUntilChanged())
  }

  updateFilter(filter){
    this.store.dispatch(new users.UpdateFilter({ filter }));
  }

}



// WEBPACK FOOTER //
// ./src/components/sidebar-screens/sidebar-screens.ts